<template>
  <div>
    <v-dialog persistent scrollable :value="showSettingsDialog">
      <v-card class="unmarkable">
        <v-card-title><v-icon>settings</v-icon>&nbsp; Settings</v-card-title>
        <v-divider />
        <v-card-text>
          <v-form
            ref="settings"
            v-model="valid"
            lazy-validation
            class="dividerMargin"
          >
            <v-slider
              v-model="numberOfVisibleFooterCommands"
              max="10"
              min="1"
              step="1"
              label="Number of visible commands in footer"
              thumb-label
            ></v-slider>
          </v-form>
          <v-divider class="dividerMargin" />
          <h4>
            Set visible data in editor
          </h4>
          <v-checkbox
            v-model="jacquardData"
            label="Jacquard data"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="colorControl"
            label="Color control"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="shaftData"
            label="Shaft data"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="driveData"
            label="Drive data"
            hide-details
          ></v-checkbox>
          <v-divider class="dividerMargin" />
          <v-checkbox
            v-model="useHmt"
            label="Use HMT for shaft"
            hide-details
          ></v-checkbox>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="onCancel">Cancel</v-btn>
          <v-btn
            color="secondary darken-1"
            text
            @click="onSave"
            :disabled="!valid"
          >
            Save and close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  TOGGLE_SHOW_EDITOR,
  UPDATE_ALL
} from "../../store/modules/settings/constants.js";
import { notificationMixin } from "../mixins/notificationMixin.js";
// const _ = require("lodash");

export default {
  name: "SettingsEditor",

  mixins: [notificationMixin],

  created: function() {
    this.setLocalStateToConfigValues();
  },

  data: function() {
    return {
      valid: false,
      numberOfVisibleFooterCommands: 3,
      jacquardData: false,
      colorControl: false,
      shaftData: false,
      driveData: false,
      useHmt: false
    };
  },
  computed: {
    showSettingsDialog() {
      return this.$store.state.settings.showSettingsEditor;
    }
  },

  watch: {
    showSettingsDialog(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.setLocalStateToConfigValues();
      }
    }
  },

  methods: {
    toggleShowSettings() {
      this.$store.dispatch(TOGGLE_SHOW_EDITOR);
    },
    onCancel() {
      this.setLocalStateToConfigValues();
      this.toggleShowSettings();
    },
    onSave() {
      this.$store.dispatch(UPDATE_ALL, {
        numberOfVisibleFooterCommands: this.numberOfVisibleFooterCommands,
        showJacquardData: this.jacquardData,
        showColorControl: this.colorControl,
        showShaftData: this.shaftData,
        showDriveData: this.driveData,
        useHmt: this.useHmt
      });
      this.toggleShowSettings();
    },
    setLocalStateToConfigValues() {
      this.numberOfVisibleFooterCommands = this.$store.state.settings.numberOfVisibleFooterCommands;
      this.jacquardData = this.$store.state.settings.showJacquardData;
      this.colorControl = this.$store.state.settings.showColorControl;
      this.shaftData = this.$store.state.settings.showShaftData;
      this.driveData = this.$store.state.settings.showDriveData;
      this.useHmt = this.$store.state.settings.useHmt;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dividerMargin {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
